import { apiClient } from '@twlvxtwlv/api'
import { type ClaimTokenRequestBody } from '@twlvxtwlv/types'

export function claimToken(requestBody: ClaimTokenRequestBody, accessToken: string) {
  return apiClient.post(`/api/claim-token`, requestBody, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })
}
